import { Box, Text } from '@mantine/core';
import { type ReactElement, type ReactNode } from 'react';

interface StatTileProps {
    label: string;
    children: ReactNode;
}

/**
 * Compact label-over-value tile on a bordered surface. Used in detail drawers
 * to show a row of summary stats; `children` is the value (text, badge, etc.).
 */
export default function StatTile({ label, children }: StatTileProps): ReactElement {
    return (
        <Box
            p="sm"
            style={{
                background: 'var(--bm-color-surface)',
                border: '1px solid var(--bm-color-border-subtle)',
                borderRadius: 'var(--bm-radius)',
            }}
        >
            <Text size="xs" c="dimmed" fw={700} mb={4} style={{ fontSize: '10px' }}>
                {label}
            </Text>
            {children}
        </Box>
    );
}
